'use strict';

import Loading from "../components/Loading";
import SearchRoutes from "../components/SearchRoutes";
import SearchFilterBlockWithTooltip from "../components/ui/search/SearchFilterBlockWithTooltip";
import Sort from "../components/ui/search/Sort";
import StickyContainer from "../components/ui/search/StickyContainer";
import Filters from "../components/search/Filters";
import NoItems from "../components/ui/search/NoItems";
import SearchListItem from "../components/ui/search/SearchListItem";
import {getAircraftsCompared, hasAircraftCompared, isAircraftComparedFlightInitiator, switchAircraftCompared} from "../helpers/aircraftCompare";
import ScrollTarget from "../components/ScrollTarget";
import Tooltip from "../components/ui/tooltip/Tooltip";
import { createRoutesValidator } from "../helpers/validators";
import { withSearchFiltersHook } from "../hooks/useSearchFilters";
import { withSearchSortHook } from "../hooks/useSearchSort";
import Sidebar from "../components/search/Sidebar";
import { replace } from "../helpers/history";

const IMAGE_DIMENSIONS = {
    LIST: '260x160',
    DETAIL: '550x360',
}
const MAX_AIRPORTS = 8

class EmptylegsSearchPageContainer extends React.Component {

    constructor(props) {
        super(props);
        
        this.state = {
            isFiltersFetching: false,
            isClassesFetching: false,
            isItemsFetching: false,
            
            total: 0,
            
            airports: [],
            filters: [],
            classes: [],
            items: [],
            
            route_error: null,
            items_error: null,
            classes_error: null,

            show_route_errors: false,
            
            selected_routes: this.getDefaultRoutes(),
            selected_filters: {},
            selected_sort: 'price:asc',
            
            stickyProps: { isSticky: false, wrapHeight: 0, containerHeight: 0, stickyTop: 0 },

            aircrafts_compared: [],
        }

        this.abortController = new AbortController();
        this.routesRef = React.createRef();
        this.contentRef = React.createRef();
        this.resultsRef = React.createRef();
        this.handleReloadDelayed = _.debounce(this.reloadData.bind(this), 1000);
        this.handleNoItemsSetErrors = this.handleNoItemsSetErrors.bind(this);
        
        this.routesValidator = createRoutesValidator();
    }

    componentDidMount() {
        
        const {selected_routes} = this.state;
        this.routesValidator.validate(selected_routes);
        this.setState({route_error: this.routesValidator.errors})
        
        if (window.flight_id) this.handleItemClick(window.flight_id)
        
        this.fetchInitData()
        
        listenEvent('react.aircraftComparedAdded', () => this.updateAircraftsCompared())
        listenEvent('react.aircraftComparedRemoved', () => this.updateAircraftsCompared())
    }

    fetchInitData() {
        this.setInitialLoaders()
        
        this.fetchAirports()
        this.clearFilters()
        this.fetchAircraftClasses()
        this.fetchItems({load: false})
    }
    
    setInitialLoaders() {
        this.setState({
            isClassesFetching: true,
            isItemsFetching: true,
        })
    }
    
    fetchAirports() {
        requestAction.initData(true, MAX_AIRPORTS).then(response => {
            this.setState({
                airports: response.airports,
            })
        })
    }
    
    
    clearFilters() {
        this.setState({
            selected_filters: {},
        })
    }
    
    fetchAircraftClasses() {
        this.setState({
            isClassesFetching: true,
            classes: [],
            classes_error: null,
        })
        searchAction.fetchAircraftClasses()
            .then((result) => this.setState({classes: result}))
            .catch((result) => {
                console.error(result)
                this.setState({classes_error: tMsg('Классы самолета недоступны')})
            })
            .finally((result) => this.setState({isClassesFetching: false}))
    }

    fetchItems({load = false}) {
        
        this.abortController.abort()
        this.abortController = new AbortController();
        const abortSignal = this.abortController.signal

        const { searchFilters } = this.props;
        const { items } = this.state;
        
        const routes = this.getRoutesFormData()
        const dimensions = [IMAGE_DIMENSIONS.LIST]
        
        this.setState({
            isItemsFetching: true,
            items: load ? items : [],
            items_error: null,
        })
        
        const data = {}
        if (routes) data.routes = routes
        if (dimensions) data.imageDimensions = dimensions
        
        searchAction.fetchEmptylegItems(data, abortSignal)
            .then((result) => {
                if (abortSignal.aborted) return
                const newItems = this.preparedItems(result.items || [], load)
                
                this.setState({
                    items: newItems,
                    total: result.pagination.total,
                }, () => {
                    searchFilters.recountFilters(newItems)
                })
            })
            .catch((result) => {
                if (abortSignal.aborted) return
                console.error(result)
                this.setState({items_error: tMsg('Произошла ошибка при загрузке данных')})
            })
            .finally((result) => {
                if (abortSignal.aborted) return
                this.setState({isItemsFetching: false})
            })
    }
    
    preparedItems(items = [], load = false) {
        const newItems = load ? this.mergeItems(items) : [...items];
        return this.combineEqualItems(newItems)
    }

    combineEqualItems(items = []) {

        // Если одинаковые equality_key, то берем тот, у кого цена меньше

        const filteredItems = [];

        items.map((item) => {

            const index = filteredItems.findIndex((e) => e.equality_key === item.equality_key);

            // Если нет equality_key или еще нет элемента в массиве
            if (!item.equality_key || index === -1) {
                filteredItems.push(item);
                return;
            }

            // Если цена нового элемента меньше - заменяем
            if (filteredItems[index].prices.price_sort > item.prices.price_sort)
                filteredItems.splice(index, 1, item);
        });

        return filteredItems;
    }
    
    mergeItems(newItems = []) {
        // Если в бд изменения и придут те же
        const {items} = this.state;
        const mergedItems = [...items];
        (newItems || []).map((item) => {
            if (!items.find(e => parseInt(e.id) === parseInt(item.id)))
                mergedItems.push(item)
        })
        return mergedItems
    }

    reloadData() {
        const { searchFilters } = this.props;
        searchFilters.resetFilters();

        this.routesRef.current.scroll(600);
        this.fetchItems({load: false})
    }
    
    getSelectedSort() {
        const {selected_sort} = this.state
        return selected_sort
    }

    setSelectedSort(value) {
        this.setState({
            selected_sort: value
        })
    }
    
    handleFiltersSelectedChange(values) {
        this.setState({
            selected_filters: values,
        })
    }
    
    getDefaultRoutes() {
        return [{
            from: {},
            to: {},
            date: '',
            time: '',
            seats: 0,
        }]
    }
    
    isSelectedRoutesCompleted() {
        const {selected_routes} = this.state
        return (selected_routes || []).every(({from, to, date, time, seats}) => {
            return from && from.id && from.type
                && to && to.id && to.type
                && !!date && !!time && !!seats
        })
    }
    
    getRoutesFormData() {
        const {selected_routes} = this.state
        return JSON.stringify(this.getDefaultRoutes()) === JSON.stringify(selected_routes)
            ? []
            : selected_routes
    }

    handleChangeRoutes(routes) {
        const {selected_routes} = this.state;
        
        if (JSON.stringify(selected_routes) === JSON.stringify(routes))
            return;

        this.routesValidator.validate(routes);
        this.state.show_route_errors = false;
        this.setState({
            selected_routes: routes,
            selected_filters: {},
            route_error: this.routesValidator.errors,
        }, this.handleReloadDelayed)
    }
    
    getRoutes() {
        const {selected_routes} = this.state
        return selected_routes
    }

    handleStickyChange({ isSticky, wrapHeight, containerHeight, stickyTop }) {
        this.setState({
            stickyProps: { isSticky, wrapHeight, containerHeight, stickyTop }
        })
    }
    
    handleWatchThePriceClick() {
        // todo чо делать?
        console.log('yes subscribe me')
    }

    getSearchLink() {
        let link = '/search';
        const query = apiAction.queryString(
            {r: searchAction.transformRoutesCompact(this.getRoutesFormData())}
        );
        return link + (query ? `?${query}` : '');
    }

    isItemInCompare(id) {
        return hasAircraftCompared(id)
    }

    isItemCompareInitiator(aircraft_id, flight_id) {
        return isAircraftComparedFlightInitiator(aircraft_id, flight_id)
    }
    
    handleCompareClick({aircraft, id}) {
        switchAircraftCompared({...aircraft, initiator_id: id})
        this.updateAircraftsCompared()
    }

    updateAircraftsCompared() {
        this.setState({aircrafts_compared: getAircraftsCompared()})
    }
    
    onRoutesFocus() {
        this.routesRef.current.scroll(600)
    }
    
    handleItemClick(id) {
        const {selected_routes} = this.state
        $.fancybox.open({
            src: '#reactFlightSearchModal',
            afterShow: () => {
                raiseEvent('react.selectFlightOffer', {id, showForm: true, routes: selected_routes, imageDimensions: IMAGE_DIMENSIONS.DETAIL});
                replace(`emptylegs/${id}`)
            },
            afterClose: () => {
                raiseEvent('react.selectFlightOffer', {item: null});
                replace(`emptylegs`)
            }
        })
    }

    handleShowCompareClick() {
        $.fancybox.open({
            src: '#reactAircraftCompareModal',
            props: {
                tab: this.state.aircrafts_compared.length > 0 ? 'models' : 'classes',
            },
            afterShow: () => {
                raiseEvent('react.openCompareAircraft', {});
            },
            afterClose: () => {
                raiseEvent('react.openCompareAircraft', {});
            }
        })
    }
    
    handleNoItemsSetErrors() {
        this.setState({ show_route_errors: this.routesValidator.hasErrors });
        this.routesRef.current.scroll(300);
    } 
    getIsRoutesFull() {
        return !this.routesValidator.hasErrors;
    }

    getItemsFilteredSorted() {
        const { items } = this.state

        const {
            searchFilters: { filterItems },
            searchSort: { sortItems },
        } = this.props;

        const filteredItems = filterItems(items, this.state.selected_filters)
        const sortedItems = sortItems(filteredItems, this.state.selected_sort)

        return sortedItems;
    }

    render() {
        const {isItemsFetching} = this.state
        const {airports, selected_filters, total, aircrafts_compared} = this.state
        const {items_error, show_route_errors, route_error} = this.state
        const {stickyProps: {wrapHeight}} = this.state
        
        const {
            searchFilters: { filterFilters, loading: isFiltersFetching, error: filtersError },
            searchSort: { sort }
        } = this.props;

        const filters = filterFilters(selected_filters)

        const displayItems = this.getItemsFilteredSorted()
        
        const isRouteFull = this.getIsRoutesFull()
        const showNoItems = !isItemsFetching && (items_error || displayItems.length === 0)
        const showRouteErrors = showNoItems && show_route_errors
        
        return <div className="container2">
            <div className="el-page">
                
                <div className="el-page-tile">
                    <h3>Empty Legs</h3>
                    <div>
                        <div style={{fontSize: '21px', lineHeight: 1.8, fontWeight: 500}}>
                            {tMsg('Что такое Эмпти Легс (Empty Legs) и как это работает?')}
                        </div>
                        <p dangerouslySetInnerHTML={{__html: tMsg('Empty Legs — рейсы, которые возвращаются на базу после основного маршрута, их можно забронировать по специальной цене с выгодой до 75%. Отличный шанс испытать все преимущества частной авиации — максимальный комфорт, гибкость и премиальный сервис по приятной цене. </br>Тот же борт. Тот же сервис. Более гибкое планирование.')}}/>
                    </div>
                </div>

                <ScrollTarget offsetDown={-30} offsetUp={-100} ref={this.routesRef} />

                <StickyContainer stickyPadding={20} onChange={data => this.handleStickyChange(data)}>
                    
                    <SearchRoutes
                        type={'plane'}
                        routes={this.getRoutes()}
                        airports={airports}
                        maxRoutes={1}
                        dropDownParent={'.search'}
                        onlyAirports={true}
                        maxAirports={8}
                        errors={showRouteErrors ? route_error : undefined}
                        onFocus={() => this.onRoutesFocus()}
                        onChangeRoutes={(routes) => this.handleChangeRoutes(routes)}
                    />

                    <div className="el-sorting">
                        <div className="el-sorting__row">

                            {isItemsFetching && <div className="el-sorting__count">
                                <div className="progress-bar">
                                    <div className="progress-bar-text">
                                        {tMsg('Ищем самолеты...')}
                                    </div>
                                    <span className="progress-bar-inner" style={{width:"30%"}}></span>
                                </div>
                            </div>}

                            {!isItemsFetching && <div className="el-sorting__count">
                                {`${displayItems.length} ${plural(displayItems.length, tMsg("предложение|предложения|предложений"))}`}
                            </div>}

                            <Sort items={sort} value={this.getSelectedSort()}
                                  onChange={(value) => this.setSelectedSort(value)}/>

                            <div className="el-sorting__control">
                                <div className="el-sorting__compare">
                                    <a role='button' className="el-sorting__compare-link"
                                       onClick={() => this.handleShowCompareClick()}>
                                        <i className="icon-compare2"></i>
                                        {aircrafts_compared.length > 0 &&
                                            <b style={{display: 'inline'}}>{aircrafts_compared.length}</b>}
                                        <span>{tMsg('Сравнение')}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </StickyContainer>

                <div className="el-row">
                    <div className="el-column">
                        <Sidebar top={wrapHeight + 20}>
                            {/* Пока убрано */ false && this.isSelectedRoutesCompleted() && <SearchFilterBlockWithTooltip
                                title={'Следить за ценой'}
                                tooltip_title={'Будем рассказывать про самые выгодные самолеты в этом поиске'}
                                onClick={this.handleWatchThePriceClick}
                            />}

                            <div className="el-sidebar__item">
                                <Filters
                                    filters={filters}
                                    values={selected_filters}
                                    isLoading={isFiltersFetching}
                                    error={filtersError}
                                    onChange={(values) => this.handleFiltersSelectedChange(values)}
                                />
                            </div>
                            
                        </Sidebar>
                    </div>
                    
                    <div ref={this.contentRef} className="el-content">

                        <ScrollTarget ref={this.resultsRef} offset={-90 - (wrapHeight || 0)} className="results">

                            {showNoItems && <NoItems
                                title={items_error || undefined}
                                link={ isRouteFull ? this.getSearchLink() : undefined }
                                onClick={ isRouteFull ? undefined : this.handleNoItemsSetErrors }
                            />}

                            {!items_error && (displayItems || []).map((item) => {
                                return <SearchListItem
                                    key={`item-${item.id}`}
                                    item={item}
                                    imageSize={IMAGE_DIMENSIONS.LIST}
                                    onClick={(id) => this.handleItemClick(id)}
                                    isInCompare={this.isItemInCompare(item.aircraft_compare.id)}
                                    isCompareInitiator={this.isItemCompareInitiator(item.aircraft_compare.id, item.id)}
                                    onCompareClick={() => this.handleCompareClick({aircraft: item.aircraft_compare, id: item.id})}
                                />
                            })}

                            {<Loading active={isItemsFetching} absolute={false} style={{
                                borderTop: '3px solid #e9e9e9',
                                borderLeft: '3px solid #e9e9e9',
                                borderRight: '3px solid #e9e9e9'
                            }}/>}
                        </ScrollTarget>
                    </div>
                    
                </div>
            </div>
            
            <Tooltip />
        </div>
    }
}

const domContainer = document.querySelector('#reactEmptylegsSearchPageContainer');
const root = ReactDOM.createRoot(domContainer);
root.render(React.createElement(
    withSearchFiltersHook(
        withSearchSortHook(
            EmptylegsSearchPageContainer
        ),
        { enableIsEmptylegFilter: false }
    )));
